import layoutHeaderAside from '@/layout/header-aside'
import layoutHeaderNoAside from '@/layout/header-only'

// 导入模块
import robot from './modules/robot'
import cep from '@/router/modules/cep'
import workbench from '@/router/modules/workbench'
import user from '@/router/modules/user'
import rmplus from '@/router/modules/rmplus'
import my from '@/router/modules/my'
import mp from '@/router/modules/mp'
import media from '@/router/modules/media'
import interview from '@/router/modules/interview'
import apply from '@/router/modules/apply'
import insight from '@/router/modules/insight'
import mobile from '@/router/modules/mobile'
import cloud from '@/router/modules/cloud'
import tyc from '@/router/modules/tyc'
import spread from '@/router/modules/spread'
import mediadata from '@/router/modules/mediadata'
import topic from '@/router/modules/topic'
import system from '@/router/modules/system'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)
/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/index',
    redirect: { name: 'index' },
    component: layoutHeaderNoAside,
    children: [
      // 首页
      {
        path: 'index',
        name: 'index',
        meta: {
          auth: true
        },
        component: _import('index')
      },
    ]
  },
  {
    path: '/test',
    redirect: { name: 'test' },
    component: layoutHeaderNoAside,
    children: [
      // 首页
      {
        path: 'test',
        name: 'test',
        meta: {
          auth: true
        },
        component: _import('system/test')
      }
    ]
  },
  {
    path: '/log',
    redirect: { name: 'log' },
    component: layoutHeaderNoAside,
    children: [
      {
        path: 'log',
        name: 'log',
        meta: {
          auth: true
        },
        component: _import('system/message')
      }
    ]
  },
  {
    path: '/',
    redirect: { name: 'index' },
    component: layoutHeaderAside,
    children: [
      // 首页
      // {
      //   path: 'index',
      //   name: 'index',
      //   meta: {
      //     auth: true
      //   },
      //   component: _import('index')
      // },

      // 系统 前端日志

      // 刷新页面 必须保留
      {
        path: 'refresh',
        name: 'refresh',
        hidden: true,
        component: _import('system/function/refresh')
      },
      // 页面重定向 必须保留
      {
        path: 'redirect/:route*',
        name: 'redirect',
        hidden: true,
        component: _import('system/function/redirect')
      }
    ]
  },
  workbench,
  insight,
  interview,
  apply,
  cep,
  robot,
  user,
  rmplus,
  my,
  mp,
  media,
  mobile,
  cloud,
  tyc,
  spread,
  mediadata,
  topic, //选题
  system
]

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: _import('system/login')
  },
  // 内容投稿
  // 投稿界面
  {
    path: '/article-submit',
    name: 'articles-edit',
    meta: {
      title: '投稿界面',
      auth: false
    },
    component: () => import('@/views/articles/edit-article')
  },
  // 头条录入页面
  {
    path: '/rmplus/toutiao/edit',
    name: 'toutiao-edit',
    meta: {
      title: '头条录入页面',
      auth: true
    },
    component: () => import('@/views/rmplus/toutiao/add/index')
  }
]

/**
 * 错误页面
 */
const errorPage = [
  {
    path: '*',
    name: '404',
    component: _import('system/error/404')
  }
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut,
  ...errorPage
]
